import createIcon from '../../createIcon';

/**
 * @component @name Speaker
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMkg3QzUuOSAyIDUgMi45IDUgNFYyMEM1IDIxLjEgNS45IDIxLjk5IDcgMjEuOTlMMTcgMjJDMTguMSAyMiAxOSAyMS4xIDE5IDIwVjRDMTkgMi45IDE4LjEgMiAxNyAyWk0xMiA0QzEzLjEgNCAxNCA0LjkgMTQgNkMxNCA3LjEgMTMuMSA4IDEyIDhDMTAuODkgOCAxMCA3LjEgMTAgNkMxMCA0LjkgMTAuODkgNCAxMiA0Wk0xMiAyMEM5LjI0IDIwIDcgMTcuNzYgNyAxNUM3IDEyLjI0IDkuMjQgMTAgMTIgMTBDMTQuNzYgMTAgMTcgMTIuMjQgMTcgMTVDMTcgMTcuNzYgMTQuNzYgMjAgMTIgMjBaTTEyIDEyQzEwLjM0IDEyIDkgMTMuMzQgOSAxNUM5IDE2LjY2IDEwLjM0IDE4IDEyIDE4QzEzLjY2IDE4IDE1IDE2LjY2IDE1IDE1QzE1IDEzLjM0IDEzLjY2IDEyIDEyIDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Speaker = createIcon('Speaker', [
  [
    'path',
    {
      d: 'M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 21.99 7 21.99L17 22C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2ZM12 4C13.1 4 14 4.9 14 6C14 7.1 13.1 8 12 8C10.89 8 10 7.1 10 6C10 4.9 10.89 4 12 4ZM12 20C9.24 20 7 17.76 7 15C7 12.24 9.24 10 12 10C14.76 10 17 12.24 17 15C17 17.76 14.76 20 12 20ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12Z',
      key: '1krpx6',
    },
  ],
]);

export default Speaker;
